import Funciones from './funciones.vue';
import RoutesUtils from '../../js/RoutesUtils.js';

// Mismo criterio que en Puestos de trabajo: el acceso de verdad lo imponen el backend y la
// entrada de menú; los roles de aquí son el respaldo de cuando aún no hay menú cargado.
const routes = [
    {
        path: '/funciones/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('funciones', ['ADMIN', 'DIRECTOR'], Funciones),
        keepAlive: true
    }
];
export default routes;
